<script setup lang="ts">
  defineProps<{
    loading?: boolean;
  }>();

  const emit = defineEmits<{
    "show-more": [];
  }>();
</script>

<template>
  <button
    type="button"
    :disabled="loading"
    class="flex w-full items-center justify-center rounded-sm px-2 py-1.5 text-sm text-muted-foreground hover:bg-accent focus:bg-accent outline-none"
    @click.stop.prevent="emit('show-more')">
    {{ loading ? "Loading..." : "Show more" }}
  </button>
</template>
